import React, { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import useAuth from '../../hooks/useAuth';
import authApiService from "../../services/authServices";
import { formatSeasonDisplayName } from "../../utils/seasonName";

const HeaderInner = ({ onToggleSidebar = () => {} }) => {
    const { logout } = useAuth();
    const location = useLocation();
    const [selectedCity, setSelectedCity] = useState(null);
    const [userCourtCity, setUserCourtCity] = useState(null);
    const [seasonData, setSeasonData] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    const [seasonNameValue, setSeasonNameValue] = useState("");


    const getSelectedSection = () => {
        if (
            (location.pathname === "/carter/playoffs" || location.pathname === "/carter/standing") &&
            seasonNameValue
        ) {
            return seasonNameValue;
        }

        switch (location.pathname) {
            case "/carter/home":
                return "Home";
            case "/carter/profile":
                return "Player Profile";
            case "/carter/schedule":
                return "Schedule";
            case "/carter/members":
                return "Members";
            case "/carter/members/record":
                return location.state?.recordType === "tournament"
                    ? "Tournament Record"
                    : "Overall Record";
            case "/carter/courts":
                return "Courts";
            case "/carter/standing":
                return "Leaderboard";
            case "/carter/playoffs":
                return "Playoffs"; 
            case "/carter/champions":
                return "Champions";
            case "/carter/users":
                return "Admin - View Users";
            case "/carter/manageRegistration":
                return "Admin - Manage Seasons";
            case "/carter/registrationForm":
                return "Admin - Add Season";
            case "/carter/editregistrationForm":
                return "Admin - Edit Season";
            case "/carter/citymanage":
                return "Admin - Manage City";
            case "/carter/updatecity":
                return "Admin - Update City";
            case "/carter/adminInbox":
                return "Admin - Inbox";
            case "/carter/activeUsers":
                return "Admin - Active User";
            case "/carter/aboutus":
                return "About";
            case "/carter/rule":
                return "Rules";
            case "/carter/contactus":
                return "Contact";
            case "/carter/feedback":
                return "Feedback";
            case "/carter/privacypolicy":
                return "Privacy Policy";
            case "/carter/terms":
                return "Terms of Use";
            case "/carter/signup":
                return "Sign-Up";

            case "/carter/administrateInbox":
                return "Admin Inbox";
            case "/carter/viewSeason":
                return "";
            case "/carter/scheduleSeason":
                return "";
            case "/carter/postscheduleSeason":
                return "";
            default:
                return "Home";
        }
    };


    const authToken = localStorage.getItem("accessToken");

    const showSeasonForm =
        location.pathname === "/carter/standing" ||
        location.pathname === "/carter/playoffs" ;
       // location.pathname === "/carter/schedule";


    useEffect(() => {
        const fetchDefaultCity = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 100));
                
                const accessToken = localStorage.getItem("accessToken");
                let storedCity = JSON.parse(localStorage.getItem("selectedCity"));
                
                if (accessToken) {
                    try {
                        const decoded = jwtDecode(accessToken);
                        const userId = decoded?.userId || decoded?.id;
                        if (userId) {
                            const res = await authApiService.get(`user/${userId}`);
                            const courtCity = res?.data?.court_city;
                            if (courtCity) setUserCourtCity(courtCity);
                            if (!storedCity && courtCity) {
                                const cityRes = await authApiService.get("cityDetails");
                                const match = cityRes?.data?.find(c => (c.name || '').toLowerCase() === (courtCity || '').toLowerCase());
                                if (match) {
                                    storedCity = match;
                                    localStorage.setItem("selectedCity", JSON.stringify(storedCity));
                                    setSelectedCity(storedCity.name);
                                    return;
                                }
                            }
                        }
                    } catch (e) {
                        console.error("Error fetching user court_city:", e);
                    }
                }
                
                if (!storedCity && !accessToken) {
                    const response = await authApiService.get("cityDetails");
                    if (response?.data?.length > 0) {
                        storedCity = response.data[0];
                        localStorage.setItem("selectedCity", JSON.stringify(storedCity));
                    }
                }
                
                if (storedCity) setSelectedCity(storedCity.name);
            } catch (error) {
                console.error("Error fetching default city:", error);
            }
        };
        fetchDefaultCity();
    }, [location.pathname]);

    // Listen for city changes from login
    useEffect(() => {
        const handleCityChange = () => {
            const storedCity = JSON.parse(localStorage.getItem("selectedCity"));
            setSelectedCity(storedCity?.name || null);
        };

        // Check for city changes on component mount
        handleCityChange();

        // Listen for storage changes
        window.addEventListener("storage", handleCityChange);
        
        // Also listen for custom city change events
        window.addEventListener("cityChange", handleCityChange);
        
        return () => {
            window.removeEventListener("storage", handleCityChange);
            window.removeEventListener("cityChange", handleCityChange);
        };
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
                const cityId = selectedCity?.id;
                const cityName = selectedCity?.name;
                setSelectedCity(cityName);

                const response = await authApiService.get("viewLeaderboard", { cityid: cityId });

                if (response.data && response.data.length > 0) {
                    setSeasonData(response.data);

                    const currentSelectedSeasonId = localStorage.getItem("selectedSeasonId");
                    if (currentSelectedSeasonId && currentSelectedSeasonId !== "0") {
                        const seasonExists = response.data.find(season => String(season.id) === currentSelectedSeasonId);
                        if (seasonExists) {
                            setSelectedValue(currentSelectedSeasonId);
                            setSeasonNameValue(formatSeasonDisplayName(seasonExists.name));
                        } else {
                            const firstSeason = response.data[0];
                            setSelectedValue(firstSeason.id);
                            setSeasonNameValue(formatSeasonDisplayName(firstSeason.name));
                            localStorage.setItem("selectedSeasonId", firstSeason.id);
                        }
                    } else {
                        const firstSeason = response.data[0];
                        if (firstSeason) {
                            setSelectedValue(firstSeason.id);
                            setSeasonNameValue(formatSeasonDisplayName(firstSeason.name));
                            localStorage.setItem("selectedSeasonId", firstSeason.id);
                        }
                    }
                } else if (response.message === "Not Found" || (response.data && response.data.length === 0)) {
                    setSeasonData([]);
                    setSelectedValue("");
                    setSeasonNameValue("");
                    localStorage.removeItem("selectedSeasonId"); // Remove old seasonId
                    console.log("No seasons found for this city - cleared season data");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    // Listen for season changes from other components
    useEffect(() => {
        const handleSeasonChange = () => {
            const selectedSeasonId = localStorage.getItem("selectedSeasonId");
            if (selectedSeasonId && selectedSeasonId !== "0") {
                const selectedSeason = seasonData.find(season => String(season.id) === selectedSeasonId);
                if (selectedSeason) {
                    setSelectedValue(selectedSeasonId);
                    setSeasonNameValue(formatSeasonDisplayName(selectedSeason.name));
                }
            }
        };

        window.addEventListener("seasonChange", handleSeasonChange);
        return () => {
            window.removeEventListener("seasonChange", handleSeasonChange);
        };
    }, [seasonData]);



    const handleChange = (event) => {
        const selectedSeasonId = event.target.value;

        const selectedSeason = seasonData.find(season => String(season.id) === selectedSeasonId);

        setSelectedValue(selectedSeasonId);
        setSeasonNameValue(selectedSeason ? formatSeasonDisplayName(selectedSeason.name) : "");
        localStorage.setItem("selectedSeasonId", selectedSeasonId);

        // Dispatch an event to notify other components
        window.dispatchEvent(new Event("seasonChange"));

        console.log("Selected season:", selectedSeasonId, selectedSeason?.name || "No name found");
    };




    return (
        <div className="row">
            <div className="col-sm-6">
                <div className="page_title">
                    <button type="button" id="sidebarCollapse" className="btn" onClick={onToggleSidebar}>
                        <i className="fa fa-align-left"></i>
                    </button>
                    <h2 className="page-title">{getSelectedSection()}</h2>
                    <div id="header">{selectedCity || userCourtCity || "Select City"}</div>
                </div>
            </div>
            <div className="col-sm-6">
                <div id="top-nav">
                    <div className="subNav">
                        <Link to="/carter/aboutus" className="first">ABOUT</Link>
                        <Link to="/carter/rule">RULES</Link>
                        <Link to="/carter/contactus">CONTACT</Link>
                        {/* <Link to="/">CITIES</Link> */}
                        <Link to="#" onClick={() => window.location.href = "/"}>CITIES</Link>

                        {/* <a href="/"></a> */}
                    </div>

                    <div className="right">
                        <div id="links">
                            <a className="ie-post-link" onClick={() => window.open('http://www.facebook.com/pages/City-Golf-League/348284351925121', '_blank')}>
                                <i className="fa fa-facebook"></i>
                            </a>
                            <a className="ie-post-link" onClick={() => window.open('https://twitter.com/CityGolfLeague', '_blank')}>
                                <i className="fa fa-twitter"></i>
                            </a>
                            <Link to="" target="_blank"><i className="fa fa-instagram"></i></Link>
                        </div>


                        <div style={{ display: 'inline-block' }}>
                            {authToken ? (
                                <div id="logout-nav">
                                    <Link to="/" onClick={logout}>LOG OUT</Link>
                                </div>
                            ) : (
                                <>
                                    <div id="signup-nav">
                                        <Link to="/carter/signup">SIGN UP</Link>
                                    </div>
                                    <div id="login-nav">
                                        <Link to="#" onClick={() => window.location.href = "/"}>LOG IN</Link>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="w-100">
                        {showSeasonForm && (
                        <form id="command" name="season">
                            <select name="seasonid" onChange={handleChange} value={seasonData.length > 0 ? selectedValue : "0"}>
                                <option value="0" disabled={seasonData.length > 0}>CHOOSE ANOTHER SEASON</option>
                                {seasonData.length > 0 ? (
                                    seasonData.map((season) => (
                                        <option key={season.id} value={season.id} >
                                            {formatSeasonDisplayName(season.name)}
                                        </option>
                                    ))
                                ) : (
                                    <option value="0" disabled>No Record Found</option>
                                )}
                            </select>
                        </form>
                    )}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>



    );
};

export default HeaderInner;
